import { render, staticRenderFns } from "./BadgeDefaqto.vue?vue&type=template&id=5af1b33c&scoped=true&"
import script from "./BadgeDefaqto.vue?vue&type=script&lang=js&"
export * from "./BadgeDefaqto.vue?vue&type=script&lang=js&"
import style0 from "./BadgeDefaqto.vue?vue&type=style&index=0&id=5af1b33c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1b33c",
  null
  
)

export default component.exports